import * as React from "react";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import { Button, Grid, Modal, Stack, Typography, IconButton } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import maintenanceLogo from "../../../assets/Card/maintenanceLogo.png";
import ArrowDown from "../../../assets/Card/fi_chevron-down.png";
import RealTimeMapWithPath from "./RealTimeMap";
export default function DashboardLocationCard() {
  const [open, setOpen] = React.useState(false);
  const [focusOnOpen, setFocusOnOpen] = React.useState(false);

  const handleOpen = () => {
    setOpen(true);
    setFocusOnOpen(true);
  };
  const handleClose = () => setOpen(false);
  const [click, setClick] = React.useState(false);
  const handleMapClick = () => {
    setClick(!click);
  };
  return (
    <Box sx={{ height: "auto", mt: { xs: 1, md: 0 } }}>
      <Card
        variant="outlined"
        sx={{
          border: "1px ",
          boxShadow: "2px 2px 5px rgba(0, 0, 0, 0.6)",
          height: { lg: "570px", xs: "340px", sm: "570px" },
          // height: { lg: "auto", xs: "340px", sm: "570px" },
          mb: 1,
        }}
      >
        <React.Fragment>
          <Stack
            direction={"row"}
            // justifyContent={"space-between"}
            width={"100%"}
            pl={1}
            pt={2}
            // height={"15%"}
            pr={1}
          >
            <Stack width={"20%"}>
              <Box
                sx={{
                  width: {
                    xs: "30px", // Extra small screens

                    md: "32px", // Medium screens
                    lg: "38px", // Large screens
                    xl: "44px", // Extra large screens
                  },
                  height: {
                    xs: "30px", // Extra small screens

                    md: "32px", // Medium screens
                    lg: "38px", // Large screens
                    xl: "44px", // Extra large screens
                  },
                  backgroundColor: "#FFF4F2",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  borderRadius: "2px",
                }}
              >
                <Box
                  width={{
                    xs: "14px", // Extra small screens

                    md: "14px", // Medium screens
                    lg: "16px", // Large screens
                    xl: "18px",
                  }}
                  height={{
                    xs: "14px", // Extra small screens

                    md: "14px", // Medium screens
                    lg: "16px", // Large screens
                    xl: "18px",
                  }}
                >
                  <img src={maintenanceLogo} height={"100%"} width={"100%"} />
                </Box>
              </Box>
            </Stack>
            <Stack width={"100%"} direction={"column"}>
              {/* {" "} */}
              <Typography
                sx={{
                  fontSize: {
                    xs: "9px", // Extra small screens

                    md: "10px", // Medium screens
                    lg: "15px", // Large screens
                    xl: "15px",
                  },
                  mt: 1,
                  color: "#3D4149",
                  fontWeight: 400,
                  fontFamily: "Inter, sans-serif",
                }}
              >
                Real Time Location
              </Typography>
            </Stack>
            <Stack pr={"10px"} onClick={handleMapClick}>
              <Button
                outline
                
                sx={{
                  backgroundColor:"#F38712",
                  color:"#ffffff",
                  "&:hover": {
                    backgroundColor: "inherit",
                    color: "inherit",
                    border:"1px solid #F38712"
                  },
                }}
              >
                Refetch
              </Button>
            </Stack>
          </Stack>

          <Box
            height={{ md: "450px", xs: "250px", sm: "450px" }}
            pl={"7px"}
            pr={"7px"}
            onClick={handleOpen}
            style={{ cursor: "pointer" }} // Change cursor to indicate clickability
          >
            <RealTimeMapWithPath click={click} setClick={setClick} />
          </Box>

          {/* Modal with the larger map */}
          <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="large-map-modal"
            aria-describedby="view-map-in-large-size"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Box
              width="90vw"
              height="90vh"
              bgcolor="background.paper"
              boxShadow={24}
              p={3}
              borderRadius={2}
              sx={{ position: 'relative' }}
            >
              <IconButton
                aria-label="close"
                onClick={handleClose}
                sx={{
                  position: 'absolute',
                  right: 8,
                  top: 8,
                  fontSize: "20px", 
                  color: (theme) => theme.palette.grey[700],
                  zIndex: 10
                }}
              >
                <CloseIcon />
              </IconButton>
              {/* <Typography
                id="large-map-modal"
                variant="h6"
                component="h2"
                mb={2}
              >
                Fullscreen Map
              </Typography> */}
              <RealTimeMapWithPath focusOnLatest={focusOnOpen} setFocusOnLatest={setFocusOnOpen} />
            </Box>
          </Modal>
        </React.Fragment>
      </Card>
    </Box>
  );
}
